import { render, staticRenderFns } from "./OrderSubmissionTime.vue?vue&type=template&id=f71e8c24&scoped=true&"
import script from "./OrderSubmissionTime.vue?vue&type=script&lang=js&"
export * from "./OrderSubmissionTime.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmissionTime.vue?vue&type=style&index=0&id=f71e8c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71e8c24",
  null
  
)

export default component.exports